import { render, staticRenderFns } from "./SimilarTravelersDataTable.vue?vue&type=template&id=2abc68d5&lang=pug&"
import script from "./SimilarTravelersDataTable.vue?vue&type=script&lang=js&"
export * from "./SimilarTravelersDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SimilarTravelersDataTable.vue?vue&type=style&index=0&id=2abc68d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports